import { useQuery } from "@tanstack/react-query";
import { RemindersKeys } from "web_myplann/Api/Reminders/RemindersKeys";
import {
	REMINDER_SORT_BY,
	REMINDER_SORT_DIRECTION,
	VISIBLE_REMINDER_STATUSES,
} from "web_myplann/Api/Reminders/remindersListParams";
import { selectReminders } from "web_myplann/Api/Reminders/selectReminders";
import { getPortfolioPortfolioIdRemindersV2 } from "web_myplann/Infrastructure/Api/Api";
import { processResponseQuery } from "web_myplann/Infrastructure/Api/ApiUtils";

export const usePortfolioRemindersListQuery = (portfolioId: number) =>
	useQuery({
		queryKey: RemindersKeys.portfolioList(portfolioId),
		queryFn: processResponseQuery(() =>
			getPortfolioPortfolioIdRemindersV2(
				portfolioId,
				VISIBLE_REMINDER_STATUSES,
				REMINDER_SORT_BY,
				REMINDER_SORT_DIRECTION,
			),
		),
		select: selectReminders,
	});
